define('controllers/myreport/myreport-payment.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('paymentReport', ['$scope', '$q', '$filter', '$stateParams', 'OpenApp', 'OpenOther', 'auiDialog', 'BalanceApp', 'ngDialog', 'HuaweiTrade', 'commonUtils',
        function ($scope, $q, $filter, $stateParams, OpenApp, OpenOther, auiDialog, BalanceApp, ngDialog, HuaweiTrade, commonUtils) {
            /* 1.变量声明 */
            var settleReturnDesc = mainCons.reportAll.settleReturnDesc;
            var startDate;
            var endDate;
            if ($stateParams.endDate && $stateParams.startDate) {
                startDate = getMonthFirstLastDay($stateParams.startDate.substr(0, 4), $stateParams.startDate.substr(4, 2))[0];
                endDate = getMonthFirstLastDay($stateParams.endDate.substr(0, 4), $stateParams.endDate.substr(4, 2))[1];
            }


            /* 2. $scope变量声明 */
            var Model = $scope.Model = {
                teamUser: AUI.HDGWCall.getUserInfoValue('teamid'),
                tabType: 'payment',
                queryPayment: {
                    appId: -1,
                    appListQueryMethod: $scope.$parent.initAppList('payment', 8),
                    regionShow: [0, 2, 1, 7, 5],
                    regionType: startDate ? 0 : 1,//0是自定义1是今天
                    startTime: startDate ? startDate : new Date(),
                    endTime: endDate ? endDate : new Date(),
                    orderNo: '',
                    tradeStatusPayment: -1,
                    serviceTypePayment: -1,
                    payTypePayment: -1,
                    sdkChannelPayment: -1,
                    countryPayment: 'ALL',
                    queryMethod: queryPaymentListBefore,
                    downloadMethod: downloadPaymentList,
                    onload: init,
                    tabType: 'payment',
                    minStartTime: new Date('1970/01/01'),
                    viewDownloadList: viewDownloadList
                },
                queryGameTicket: {
                    appId: '-1',                          //【产品下拉框】【默认值】-1
                    appListQueryMethod: $scope.$parent.initAppList('payment', 8),
                    regionShow: [0, 1, 2, 5],               //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 1,                         //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    startTime: new Date(),                 //【开始时间】【默认值】今天
                    endTime: new Date(),                   //【结束时间】【默认值】今天
                    tradeId: '',
                    tradeStatusGameTicket: -1,             //【订单状态】【默认值】-1【枚举】-1:全部状态1:预扣2:确认扣除3:预扣解除4:直接扣除成功5:直接扣除失败6:退款成功
                    countryCodes: '',
                    queryMethod: queryGameTicketListBefore,      //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadGameTicketList, //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮
                    tabType: 'gameTicket',
                    minStartTime: new Date('2017/11/01')
                },
                paginationPayment: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: queryPaymentList
                },
                paginationGameTicket: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: queryGameTicketList
                },
                constant: {
                    payType: mainCons.reportAll.payTypeCons,
                    sdkChannel: mainCons.reportAll.sdkChannelCons,
                    tradeState: mainCons.reportAll.tradeStateCons,
                    notified: mainCons.reportAll.notifiedCons,
                    country: mainCons.reportAll.country //订单的列表的国家映射
                },
                incomeGameTicket: -1,
                paymentList: null,
                gameTicketList: null,
                operType: 1
            };
            /* 3. $scope函数挂载 */
            $scope.changeTabType = changeTabType;
            $scope.queryPaymentListBefore = queryPaymentListBefore;
            $scope.queryPaymentList = queryPaymentList;
            // $scope.checkDownloadPaymentList = checkDownloadPaymentList;
            $scope.resend = resend;
            $scope.refund = refund;
            $scope.getDuration = getDuration;
            $scope.queryGameTicketListBefore = queryGameTicketListBefore;
            $scope.queryGameTicketList = queryGameTicketList;
            $scope.downloadGameTicketList = downloadGameTicketList;
            $scope.reNoticeForGame = reNoticeForGame;
            $scope.handleStrLength = commonUtils.handleStrLength;

            /* 4. 初始化函数声明与执行 */
            function init() {
                Model.tradeStatusGameTicketCons = {};
                for (var i in mainCons.reportAll.tradeStatusGameTicketCons) {
                    Model.tradeStatusGameTicketCons[mainCons.reportAll.tradeStatusGameTicketCons[i].id] = mainCons.reportAll.tradeStatusGameTicketCons[i].name;
                }
                // 初始化查询第一个标签页的数据
                changeTabType();
            }

            /* 5. 切换Tab触发的方法 */
            function changeTabType(type) {
                if (type) {
                    Model.tabType = type;
                }
                switch (Model.tabType) {
                    case 'payment':
                        if (Model.paymentList == null) {
                            queryPaymentListBefore();
                        }
                        break;
                    case 'gameTicket':
                        if (Model.gameTicketList == null) {
                            queryGameTicketListBefore();
                        }
                        break;
                }
            }

            function queryGameTicketListBefore() {
                Model.paginationGameTicket.currentPage = 1;
                Model.paginationGameTicket.itemsPerPage = Model.paginationGameTicket.itemsPerPageBackUp;
                queryGameTicketList();
            }

            function checkDateValid(startTime, endTime) {
                var startTimeDif = AUI.DateUtil.calDaysDual(startTime, "2017-11-1");
                if (startTimeDif < 1) {
                    auiDialog.fail("时间区间选择错误", "开始时间不能早于2017年11月1日。");
                    return true;
                }
                // 计算7年前日期
                var sevenYearBeforeTime = AUI.DateUtil.calDateByType(20);
                if (sevenYearBeforeTime) {
                    var sevenYearBeforeStartDate = sevenYearBeforeTime.startDate;
                    startTimeDif = AUI.DateUtil.calDaysDual(startTime, AUI.DateUtil.date2Str(sevenYearBeforeStartDate));
                    if (startTimeDif < 1) {
                        auiDialog.fail("时间区间选择错误", "开始时间不能早于7年前。");
                        return true;
                    }
                }
                // 结束日期不能和开始日期跨月,checkSameYearMonth返回false表示跨月
                if (!AUI.DateUtil.checkSameYearMonth(startTime, endTime)) {
                    auiDialog.fail("时间区间选择错误", "请保持开始日期和结束日期在同一个自然月。");
                    return true;
                }

                return false;
            }

            //获取这个当前月份的第一天和最后一天
            function getMonthFirstLastDay(year, month) {
                var firstDay = new Date(parseInt(year), parseInt(month) - 1, 1);//这个月的第一天
                var currentMonth = firstDay.getMonth(); //取得月份数
                var lastDay = new Date(firstDay.getFullYear(), currentMonth + 1, 0);//是0而不是-1
                firstDay = new Date($filter('date')(firstDay, 'yyyy-MM-dd 00:00:00'));//格式化
                lastDay = new Date($filter('date')(lastDay, 'yyyy-MM-dd 23:59:59'));//格式化
                if (lastDay > new Date()) {
                    lastDay = new Date();
                }
                return [firstDay, lastDay];
            }


            function queryGameTicketList() {
                if (interfaceBeCheck()) return;
                var param = {
                    userID: '',
                    appIdList: Model.queryGameTicket.appId == -1 ? [] : [Model.queryGameTicket.appId],
                    startDate: Model.queryGameTicket.startTime + " 00:00:00",
                    endDate: Model.queryGameTicket.endTime + " 23:59:59",
                    status: Model.queryGameTicket.tradeStatusGameTicket == -1 ? '' : Model.queryGameTicket.tradeStatusGameTicket,
                    zOrderId: Model.queryGameTicket.tradeId,
                    countries: Model.queryGameTicket.countryCodes,
                    pageFrom: Model.paginationGameTicket.currentPage,// 任何时候点击查询，默认查询第一页
                    pageCount: Model.paginationGameTicket.itemsPerPage,
                    lang: 'zh_CN'
                };
                OpenOther.openGameDeveloperQueryCouponOrderList(param).then(function (resp) {
                    if (resp.rtnCode == 0) {
                        Model.gameTicketList = resp.couponOrderList ? resp.couponOrderList : [];
                        Model.incomeGameTicket = resp.totalMondy ? resp.totalMondy : 0;
                        Model.paginationGameTicket.totalCount = resp.totalCount;
                        Model.gameTicketList.forEach(function (gameTicket) {
                            if (gameTicket.appKindName == undefined
                                || gameTicket.appKindName == null
                                || gameTicket.appKindName == "") {
                                gameTicket.appKindName = "未知";
                            }
                        });

                    } else {
                        if (resp.rtnCode == 508) {
                            auiDialog.fail("请保持开始日期和结束日期在同一个自然月。");
                        } else if (resp.rtnCode == 509) {
                            auiDialog.fail("您本次查询数据量过大，请选择更小时间范围查询优惠券明细文档。");
                        }
                        Model.gameTicketList = [];
                        Model.incomeGameTicket = 0;
                        Model.paginationGameTicket.totalCount = 0;
                    }
                });
            }

            function downloadGameTicketList() {
                if (interfaceBeCheck()) return;
                var param = {
                    userID: '',
                    appIdList: Model.queryGameTicket.appId == -1 ? [] : [Model.queryGameTicket.appId],
                    startDate: Model.queryGameTicket.startTime + " 00:00:00",
                    endDate: Model.queryGameTicket.endTime + " 23:59:59",
                    countries: Model.queryGameTicket.countryCodes,
                    status: Model.queryGameTicket.tradeStatusGameTicket == -1 ? '' : Model.queryGameTicket.tradeStatusGameTicket,
                    zOrderId: Model.queryGameTicket.tradeId,
                    lang: 'zh_CN'
                };
                $scope.$parent.downloadReport(OpenOther.openGameDeveloperDownloadCouponOrder, param, function (resp) {
                    return resp && resp.rtnCode == 0;
                });
            }

            function interfaceBeCheck() {
                if (checkDateValid(Model.queryGameTicket.startTime, Model.queryGameTicket.endTime)) {
                    return true;
                }
                if (!$scope.$parent.checkDate(Model.queryGameTicket)) {
                    auiDialog.fail("时间区间选择错误", "请填写查询时间。");
                    return true;
                }
            }

            function reNoticeForGame(orderID) {
                var param = {
                    userID: '',
                    zOrderId: orderID
                };
                OpenOther.openGameNoticePayResult(param).then(function (resp) {
                    if (resp.rtnCode == 0) {
                        auiDialog.success('补发通知成功');
                    } else {
                        auiDialog.fail('补发通知失败');
                    }
                });
            }

            function queryPaymentListBefore() {
                Model.paginationPayment.currentPage = 1;
                Model.paginationPayment.itemsPerPage = Model.paginationPayment.itemsPerPageBackUp;
                queryPaymentList();
            }

            // 查询支付明细
            function queryPaymentList() {

                Model.paymentList = null;
                var params = getQueryPaymentListParams();
                var defer = $q.defer();
                if (!$scope.$parent.checkDate(Model.queryPayment)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                    Model.paymentList = [];

                    return;
                }


                getSign(params, function (sign) {
                    params.sign = sign;
                    params.signType = "HMAC";
                    var queryTradeParams = {}
                    if (Model.teamUser) {
                        queryTradeParams = {
                            req: {userID: Model.teamUser},
                            params: angular.toJson(params)
                        };
                    } else {
                        queryTradeParams = {
                            req: {},
                            params: angular.toJson(params)
                        };
                    }
                    BalanceApp.queryTrade(queryTradeParams).then(function (resp) {
                        resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                        if (resp.returnCode == 0) {
                            if (resp.data) {
                                Model.paymentList = resp.data;
                                var prodIDs = [];
                                Model.paymentList.forEach(function (pay) {
                                    pay.applicationIDTemp = AUI.BaseJSUtil.toLegalProdID(pay.applicationID);
                                    //退款允许提交标识，第一位是1可以退款，其他不可以,rfgFlag没有值兼容以前
                                    pay.showRefund = typeof pay.rfgFlag == 'undefined' || pay.rfgFlag == null || pay.rfgFlag.indexOf && pay.rfgFlag.indexOf('1') == 0;
                                    prodIDs.push(pay.applicationIDTemp);
                                });
                                prodIDs = AUI.BaseJSUtil.unique(prodIDs);
                                if (prodIDs.length != 0) {
                                    OpenApp.queryAppList({
                                        req: {
                                            prodIDList: prodIDs,
                                            maxReqCount: 1000
                                        }
                                    }).then(function (resp) {
                                        if (resp && resp.appSrvList && resp.appSrvList.length > 0 && Model.paymentList.length > 0) {
                                            resp.appSrvList.forEach(function (appSrv) {
                                                Model.paymentList.forEach(function (pay) {
                                                    //接口会返回appInfo
                                                    if (appSrv.appInfo && pay.applicationIDTemp == appSrv.appInfo.appID) {
                                                        if (appSrv.appInfo.appLanguage && appSrv.appInfo.appLanguage.length > 0) {
                                                            appSrv.appInfo.appLanguage.forEach(function (appLang) {
                                                                //国内的只能是zh-CN
                                                                if (appLang.language == "zh-CN") {
                                                                    pay.prodName = appLang.appName;
                                                                }
                                                            })
                                                        }
                                                        if (!pay.prodName) {
                                                            pay.prodName = appSrv.appInfo.appName;
                                                        }
                                                    }
                                                })
                                            });
                                        }
                                    });
                                }
                            } else {
                                Model.paymentList = [];
                            }
                            Model.paginationPayment.totalCount = resp.count;
                        } else {
                            auiDialog.fail($filter('auiMapWithDefault')(resp.returnCode, settleReturnDesc.query_paymentOrder, '查询支付订单失败'));
                        }
                        defer.resolve();
                    }).catch(function (resp) {
                        resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                        Model.paymentList = [];
                        if (resp && resp.NSP_STATUS) {
                            auiDialog.failSystemError($filter('auiErrorCode')(resp.NSP_STATUS));
                        }
                        defer.resolve();
                    });
                    defer.resolve();
                }, function (resp) {
                    resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                    Model.paymentList = [];
                    if (resp && resp.NSP_STATUS) {
                        auiDialog.failSystemError($filter('auiErrorCode')(resp.NSP_STATUS));
                    }
                    defer.resolve();
                });
                return defer.promise;
            }


            function downloadPaymentList() {
                Model.operType = 1;
                var defer = $q.defer();
                var params = getDownloadPaymentListParams();
                getSign(params, function (sign) {
                    params.sign = sign;
                    params.signType = "HMAC";
                    var param = {req: {}};
                    if (Model.teamUser) {
                        param = {req: {userID: Model.teamUser}}
                    }
                    param.params = angular.toJson(params);
                    param.interfaceName = "pay.details.download";
                    BalanceApp.reportReportGateway(param).then(function (resp) {
                        resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                        if (resp.returnCode == 0) {
                            ngDialog.open({
                                template: "../refactor/pages/myreport/myreport.payment.download.html",
                                className: '',
                                replace: true,
                                controller: ['$scope', function ($scopeDlg) {
                                    $scopeDlg.cancle = function () {
                                        ngDialog.close();
                                    };
                                    $scopeDlg.viewDownloadList = viewDownloadList;
                                }]
                            });
                            defer.resolve();
                        } else if (resp.returnCode == 12002) {
                            auiDialog.fail('导出失败', $filter('auiMapWithDefault')(resp.returnCode, settleReturnDesc.download_paymentOrder, '请勿在5分钟内多次下载，请5分钟后再进行下载操作。'));
                            defer.reject();
                        }
                    }).catch(function (resp) {
                        resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                        auiDialog.fail($filter('auiMapWithDefault')(resp.returnCode, settleReturnDesc.download_paymentOrder, '导出失败'));
                        defer.reject();
                    });
                }, function (resp) {
                    resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                    auiDialog.fail($filter('auiMapWithDefault')(resp.returnCode, settleReturnDesc.download_paymentOrder, '导出失败'));
                    defer.reject();
                });
                return defer.promise;

            }

            function viewDownloadList() {
                ngDialog.close();
                ngDialog.open({
                    template: "../refactor/pages/myreport/myreport.payment.downloadList.html",
                    className: '',
                    replace: true,
                    controller: ['$scope', function ($scopeList) {
                        $scopeList.paginationMessage = {
                            currentPage: 1,
                            itemsPerPage: 5,
                            itemsPerPageBackUp: 5,
                            totalCount: 0,
                            noItems: "No products",
                            pagesLength: 5,
                            onChange: getData
                        };
                        getData();

                        function getData() {
                            Model.operType = 2;
                            var params1 = getDownloadPaymentListParams();
                            getSign(params1, function (sign) {
                                params1.sign = sign;
                                params1.signType = "HMAC";
                                var param = {req: {}};
                                if (Model.teamUser) {
                                    param = {req: {userID: Model.teamUser}}
                                }
                                param.params = angular.toJson(params1);
                                param.interfaceName = "pay.details.download";
                                BalanceApp.reportReportGateway(param).then(function (resp) {
                                    resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                                    if (resp && resp.returnCode == 0 && resp.downloadTasks) {
                                        $scopeList.taskList = resp.downloadTasks;
                                    } else if (resp.returnCode == 1) {
                                        auiDialog.fail('导出失败', $filter('auiMapWithDefault')(resp.returnCode, settleReturnDesc.download_paymentOrder, '查询结果超过5万上限，请缩小查询条件后再试'));
                                    } else {
                                        auiDialog.fail($filter('auiMapWithDefault')(resp.returnCode, settleReturnDesc.download_paymentOrder, '导出失败'));
                                    }
                                }).catch(function (resp) {
                                    resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                                    auiDialog.fail($filter('auiMapWithDefault')(resp.returnCode, settleReturnDesc.download_paymentOrder, '导出失败'));
                                });
                            }, function (resp) {
                                resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                                auiDialog.fail($filter('auiMapWithDefault')(resp.returnCode, settleReturnDesc.download_paymentOrder, '导出失败'));
                            });
                        }

                        $scopeList.cancle = function () {
                            ngDialog.close();
                        }
                    }]
                });

            }

            // 补发
            function resend(orderId) {
                var params = {
                    orderId: orderId
                };
                var defer = $q.defer();
                getSign(params, function (sign) {
                    params.sign = sign;
                    params.signType = "HMAC";
                    var param = {
                        params: angular.toJson(params)
                    };
                    HuaweiTrade.notifytrigger(param).then(function (resp) {
                        resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                        if (resp.returnCode == 0) {
                            auiDialog.success('申请补发成功');
                        } else {
                            auiDialog.fail($filter('auiMapWithDefault')(resp.returnCode, settleReturnDesc.notifytrigger, '申请补发失败'));
                        }
                        defer.resolve();
                    }).catch(function (resp) {
                        resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                        if (resp && resp.NSP_STATUS) {
                            auiDialog.failSystemError($filter('auiErrorCode')(resp.NSP_STATUS));
                        } else {
                            auiDialog.fail('请求失败，请稍候重试。');
                        }
                        defer.reject();
                    });
                }, function (resp) {
                    resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                    if (resp && resp.NSP_STATUS) {
                        auiDialog.failSystemError($filter('auiErrorCode')(resp.NSP_STATUS));
                    } else {
                        auiDialog.fail('请求失败，请稍候重试。');
                    }
                    defer.reject();
                });
                return defer.promise;
            }

            // 退款
            function refund(orderId, tradeAmt, tradeCurrency) {
                var defer = $q.defer();
                ngDialog.open({
                    template: '../refactor/pages/myaccount/earnings/account.earnings.refund.html',
                    replace: true,
                    className: '',
                    controller: ['$scope', function ($scopeDlg) {
                        $scopeDlg.tradeCurrency = tradeCurrency;
                        $scopeDlg.checkRefoundAmt = function () {
                            if (!isPositiveNumberLimit($scopeDlg.refoundTradeAmt)) {
                                $scopeDlg.warn = '请输入正数金额且小数点后最多只能保留两位。';
                                return false;
                            }

                            if (Number($scopeDlg.refoundTradeAmt) > 999999) {
                                $scopeDlg.warn = '退款金额不能大于999999元。';
                                return false;
                            } else if (Number($scopeDlg.refoundTradeAmt) > Number(tradeAmt)) {
                                $scopeDlg.warn = '退款金额不能大于订单的支付金额。';
                                return false;
                            }
                            $scopeDlg.warn = '';
                            return true;
                        };
                        $scopeDlg.submit = function () {
                            ngDialog.close();

                            if ($scopeDlg.refoundTradeAmt.indexOf('.') < 0) {
                                $scopeDlg.refoundTradeAmt = $scopeDlg.refoundTradeAmt + '.00';
                            }

                            var params = {
                                orderID: orderId,
                                sourceID: 'LEAGUE',
                                amount: $scopeDlg.refoundTradeAmt
                            };
                            params.sign = getSignData(params);
                            OpenOther.tradeRefund(params).then(function (resp) {
                                if (resp.retCode == 0) {
                                    auiDialog.success("退款成功", function () {
                                        queryPaymentListBefore();
                                    });
                                } else {
                                    auiDialog.fail($filter('auiMapWithDefault')(resp.retCode, settleReturnDesc.tradeRefund, '退款失败'));
                                }
                                defer.resolve();
                            }).catch(function (data) {
                                defer.reject();
                            });

                        };
                        $scopeDlg.cancel = function () {
                            ngDialog.close();
                            defer.reject();
                        }
                    }]
                });
                return defer.promise;
            }

            function getQueryPaymentListParams() {
                var params = {
                    startTime: Model.queryPayment.startTime + ' 00:00:00',
                    endTime: Model.queryPayment.endTime + ' 23:59:59'
                };
                if (Number(Model.queryPayment.appId) != -1) {
                    params.applicationID = Model.queryPayment.appId;
                }
                if (Model.queryPayment.orderNo) {
                    params.orderNo = Model.queryPayment.orderNo;
                }
                if (Model.queryPayment.tradeStatusPayment != -1) {
                    params.tradeState = Model.queryPayment.tradeStatusPayment;
                }
                if (Model.queryPayment.serviceTypePayment != -1) {
                    params.type = Model.queryPayment.serviceTypePayment;
                }
                if (Model.queryPayment.payTypePayment != -1) {
                    params.paytype = Model.queryPayment.payTypePayment;
                }
                if (Model.queryPayment.sdkChannelPayment != -1) {
                    params.sdkChannel = Model.queryPayment.sdkChannelPayment;
                }
                if (!Model.queryPayment.countryPayment) {
                    params.country = 'ALL';
                } else {
                    params.country = Model.queryPayment.countryPayment;
                }
                params.pageNo = Model.paginationPayment.currentPage;
                params.pageSize = Model.paginationPayment.itemsPerPage;
                return params;
            }

            function getDownloadPaymentListParams() {
                var params = getQueryPaymentListParams();
                params.pageNo = 1;
                params.pageSize = 50000;
                params.langType = 'zh_cn';//导出文件语言
                params.operType = Model.operType;
                return params;
            }

            // 获取支付签名
            function getSign(data, callback, errorCallback) {
                var param = {
                    "params": angular.toJson({
                        "content": getSignData(data),
                        "signtype": "HMAC",
                        "keytype": "trade-hmacsha256"
                    })
                };
                BalanceApp.signName(param).then(function (resp) {
                    resp = angular.fromJson(resp);
                    if (resp.returnCode == 0) {
                        callback(resp.sign);
                    }
                }).catch(function (resp) {
                    errorCallback && errorCallback(resp);
                })
            }


            function getSignData(paras) {
                var content = "";
                var cell;
                var parasArr = [];
                for (var i in paras) {
                    cell = {};
                    cell.key = i;
                    cell.value = paras[i];
                    parasArr.push(cell);
                }
                parasArr.sort(function (a, b) {
                    if (a.key + "" > b.key + "")
                        return 1;
                    else
                        return -1;
                });
                for (var j = 0; j < parasArr.length; j++) {
                    var key = parasArr[j].key;
                    var value = parasArr[j].value;
                    if ("sign" == key) {
                        continue;
                    }
                    if (value != null && value != undefined) {
                        content += (j == 0 ? "" : "&") + key + "=" + value;
                    } else {
                        content += (j == 0 ? "" : "&") + key + "=";
                    }
                }
                return content;
            }

            /*时长固定用tradetime - ordertime*/
            function getDuration(start, end) {
                return (Date.parse(end.replace(/-/g, "/")) - Date.parse(start.replace(/-/g, "/"))) / 1000;
            }

            function isPositiveNumberLimit(str) {
                var isPositiveNum = false;
                if (str == 0) {
                    isPositiveNum = false;
                } else if (AUI.BaseJSUtil.isNaturalNumber(str)) {
                    isPositiveNum = true;
                } else {
                    if (str) {
                        var reg = /^(0|[1-9]\d*)\.(\d{1,2})$/;

                        if (reg.test(str)) {
                            isPositiveNum = true;
                        }
                    }
                }
                return isPositiveNum;
            }

        }]
    );
});

